(function () {

  const scriptEl = document.currentScript || document.querySelector('script[src$="media-grid_override-enchliving.js"]');
  function findSection() {
    if (scriptEl) {
      const s = scriptEl.closest('[id^="shopify-section-"]') || scriptEl.closest('.shopify-section');
      if (s) return s;
    }
    return document.querySelector('.media-grid--enchliving') || null;
  }
  const mqMobile = window.matchMedia('(max-width: 699px)');

  function getOrderValue(el, isMobile) {
    const attr = isMobile ? 'data-mobile-order' : 'data-desktop-order';
    const v = el.getAttribute(attr);
    return v && !isNaN(Number(v)) ? Number(v) : Number(el.getAttribute('data-original-index')) || 0;
  }

  function reorderGrid() {
    const section = findSection();
    if (!section) return;
    const grid = section.querySelector('media-grid.media-grid') || section.querySelector('.media-grid');
    if (!grid) return;

    const isMobile = mqMobile.matches;
    const items = Array.from(grid.children);

    items.sort((a, b) => {
      const oa = getOrderValue(a, isMobile);
      const ob = getOrderValue(b, isMobile);
      if (oa === ob) {
        return Number(a.getAttribute('data-original-index')) - Number(b.getAttribute('data-original-index'));
      }
      return oa - ob;
    });

    items.forEach(item => grid.appendChild(item));
  }

  window.addEventListener('load', reorderGrid);
  window.addEventListener('resize', debounce(reorderGrid, 150));
  window.addEventListener('orientationchange', debounce(reorderGrid, 150));

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(reorderGrid, 50); });
})();